export default __webpack_public_path__ + "static/media/pic78.69ea6404.jpg";